import React from "react";
import { Button, useTheme } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const BackButton = ({
    label = "Voltar",
    fullWidth = false,
    disabled = false,
    fullHeight = false,
    type = "button",
    onClick = null,
    variant = "text",
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Button
            variant={variant}
            color="primary"
            startIcon={<FaArrowLeft style={{ fontSize: '12px' }} />}
            onClick={() => Boolean(onClick) ? onClick() : navigate(-1)}
            component={RouterLink}
            fullWidth={fullWidth}
            disabled={disabled}
            sx={{ height: fullHeight ? "100%" : undefined }}
            type={type}
        >
            {label}
        </Button>
    );
}

export default BackButton;
